import { render, staticRenderFns } from "./IconNewTab.vue?vue&type=template&id=29374812&"
import script from "./IconNewTab.vue?vue&type=script&lang=js&"
export * from "./IconNewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports